import i18next from 'i18next';

i18next.addResources('es', 'projectDetail', {
  seeTechnicalSheet: 'Ver ficha técnica',
  objectives: 'Objetivos',
  zoomMap: 'Ampliar mapa',
  lastUpdate: 'Ultima actualización ',
  countries: 'Países',
  dollarsInvested: 'Inversión estimada (USD)',
  projects: 'Proyectos',
  projectDetail: 'Detalle de Proyecto',
  interestContent: 'También podría interesarte',
  technicalSheet: 'Ficha Técnica',
  documents: 'Documentos',
  images: 'Imágenes',
  links: 'Links'
});

i18next.addResources('en', 'projectDetail', {
  seeTechnicalSheet: 'View technical sheet',
  objectives: 'Objectives',
  zoomMap: 'Zoom map',
  lastUpdate: 'Last update ',
  countries: 'Countries',
  dollarsInvested: 'Estimated investment (USD)',
  projects: 'Projects',
  projectDetail: 'Project Detail',
  interestContent: 'You might also be interested in',
  technicalSheet: 'Technical Sheet',
  documents: 'Documents',
  images: 'Images',
  links: 'Links'
});

i18next.addResources('pt', 'projectDetail', {
  seeTechnicalSheet: 'Ver ficha técnica',
  objectives: 'Objetivos',
  zoomMap: 'Ampliar mapa',
  lastUpdate: 'Última atualização ',
  countries: 'Países',
  dollarsInvested: 'Investimento estimado (USD)',
  projects: 'Projetos',
  projectDetail: 'Detalhe do Projeto',
  interestContent: 'Você também pode se interessar',
  technicalSheet: 'Ficha Técnica',
  documents: 'Documentos',
  images: 'Imagens',
  links: 'Links'
});
